/* eslint-disable no-unused-vars */
import { yupResolver } from '@hookform/resolvers/yup';
import { Alert, Box, Button, Grid, Typography } from '@mui/material';
import ApiClass from 'Api/ApiClient';
import AuthContext from 'context/AuthContext';
import { useContext, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { manageBidirectionalTemplateSchema } from 'schemaValidations/manageBidirectionalTemplateSchema';
import classes from 'styles/globalStyle.module.scss';
import { UrlHelpers } from 'urlHelpers/urlHelper';

import CustomInputBox from 'components/CustomInputBox/CustomInputBox';
import CustomMultilineInput from 'components/CustomMultilineInput/CustomMultilineInput';
import CustomRadioButton from 'components/CustomRadioButton/CustomRadioButton';
import CustomSelectBox from 'components/CustomSelectBox/CustomSelectBox';
import Loader from 'components/Loader/Loader';

import BidirectionalTemplateList from './TemplateBidirectionalList';

const ManageBidirectionalTemplate = () => {
  const [loader, setLoader] = useState(false);
  const ApiClient = new ApiClass();
  const [postMsg, setPostMsg] = useState('');
  const [dropDownList, setDropdownList] = useState({});
  const { userID, username, fullName } = useContext(AuthContext);
  const {
    control,
    watch,
    setValue,
    formState: { errors },
    handleSubmit,
    clearErrors,
  } = useForm({
    mode: 'all',
    defaultValues: {
      manageTemplate: '',
      newDomain: '',
      domain: '',
      templateType: '',
      eventName: '',
      subject: '',
      msgContent: '',
    },
    resolver: yupResolver(manageBidirectionalTemplateSchema),
  });
  console.log('errors', errors);
  const [watchManageTemplate, watchTemplateType] = watch(['manageTemplate', 'templateType']);
  console.log('watch all', watch());
  const createDomain = async (data) => {
    console.log('data', data);
    try {
      setLoader(true);
      const resp = await ApiClient.post(
        `${UrlHelpers.createDomain}`,
        {
          source: data.newDomain,
          templateCategory: 'bidirectional',
          createdBy: username,
        },
        {
          headers: { 'Content-Type': 'application/json' },
        },
        'templateAccessToken'
      );
      setPostMsg({ severity: 'success', message: resp?.message });
      setValue('newDomain', '');
    } catch (e) {
      console.log('e', e);
      setPostMsg({
        severity: 'error',
        message: e?.response?.data?.message || 'Internal server error',
      });
    } finally {
      setLoader(false);
    }
  };

  const manageTemplate = async (data) => {
    console.log('manage temp', data);
    try {
      setLoader(true);
      let payload = {
        createdBy: username,
        source: data?.domain,
        jsontypes: data?.templateType,
        templateCategory: 'bidirectional',
        templateNameFromApi: data?.eventName,
        // bidirectionalBody: data?.msgContent,
        bidirectionalBody: JSON.parse(data?.msgContent),
      };
      const resp = await ApiClient.post(
        `${UrlHelpers.manageTemplate}`,
        payload,
        {
          headers: { 'Content-Type': 'application/json' },
        },
        'templateAccessToken'
      );
      setPostMsg({ severity: 'success', message: resp?.Bidirectional });

      resetInputFields();
    } catch (e) {
      console.log('e', e);
      setPostMsg({
        severity: 'error',
        message: e?.response?.data?.message || 'Internal server error',
      });
    } finally {
      setLoader(false);
    }
  };

  useEffect(async () => {
    setValue('newDomain', '');
    setValue('domain', '');
    setValue('templateType', '');
    setValue('eventName', '');
    setValue('subject', '');
    setValue('msgContent', '');
    setPostMsg('');
    clearErrors();
    if (watchManageTemplate === 'maintain' || watchManageTemplate === 'list') {
      const metaData = await getMetaData();
      setDropdownList(metaData);
    }
  }, [watchManageTemplate]);
  const getMetaData = async () => {
    try {
      setLoader(true);
      const url = `${UrlHelpers.getTemplateMetaData}?templateCategory=bidirectional`;
      return await ApiClient.get(url, {}, 'templateAccessToken');
    } catch (e) {
      setPostMsg({ severity: 'error', message: 'Error in fetching dropdowns' });
      return '';
    } finally {
      setLoader(false);
    }
  };
  const onSubmit = (data) => {
    console.log('submitted data', data);
  };
  const resetInputFields = () => {
    setValue('eventName', '');
    setValue('subject', '');
    setValue('msgContent', '');
    clearErrors(['eventName', 'subject', 'msgContent']);
  };
  return (
    <Box>
      <Typography variant="h3" component="h3" my={2} className={classes.heading}>
        Manage Bidirectional Template
      </Typography>
      <Loader open={loader} />
      <Grid container>
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <CustomRadioButton
            displayInline
            name="manageTemplate"
            control={control}
            radioValues={[
              { label: 'Create New Source', value: 'new' },
              { label: 'Maintain Template', value: 'maintain' },
              { label: 'Template List', value: 'list' },
            ]}
            label="Select one option from the below"
            errors={!!errors?.manageTemplate}
            errorText={errors?.manageTemplate?.message}
          />
        </Grid>
        {postMsg && (
          <Alert
            severity={postMsg?.severity}
            onClose={() => {
              setPostMsg('');
            }}
            sx={{ margin: '8px', width: '100%' }}
            data-testid="post-failure-alert"
          >
            {postMsg?.message}
          </Alert>
        )}
        {watchManageTemplate === 'new' && (
          <Box sx={{ width: '100%' }}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <CustomInputBox
                control={control}
                errors={!!errors?.newDomain}
                errorText={errors?.newDomain?.message}
                maxLength="50"
                regex={/^[A-Za-z0-9-]*$/}
                placeholder="Enter source name"
                label="New Source"
                name="newDomain"
                required
                flexDirection="column"
              />
            </Grid>
            <Grid container item justifyContent="flex-end">
              <Button variant="contained" color="secondary" onClick={handleSubmit(createDomain)}>
                Save
              </Button>
            </Grid>
          </Box>
        )}
        {watchManageTemplate === 'maintain' && (
          <Grid container justifyContent="space-between" m={0}>
            <Grid item lg={5.5} md={5.5} sm={12} xs={12}>
              <CustomSelectBox
                flexDirection="column"
                label="Choose Source"
                options={dropDownList?.sourceList?.map((x) => ({ name: x, value: x }))}
                control={control}
                name="domain"
                errors={!!errors?.domain}
                errorText={errors?.domain?.message}
                required
                displayEmpty
              />
            </Grid>
            <Grid item lg={5.5} md={5.5} sm={12} xs={12}>
              <CustomSelectBox
                flexDirection="column"
                label="Choose Type"
                options={dropDownList?.jsontypesList?.map((x) => ({
                  name: x?.displayValue,
                  value: x?.actualValue,
                }))}
                control={control}
                name="templateType"
                errors={!!errors?.templateType}
                errorText={errors?.templateType?.message}
                required
                displayEmpty
                isValue
                valueChange={resetInputFields}
              />
            </Grid>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <CustomInputBox
                control={control}
                errors={!!errors?.eventName}
                errorText={errors?.eventName?.message}
                maxLength="50"
                regex={/^[A-Za-z0-9-]*$/}
                placeholder="Enter File Name"
                label="File name"
                name="eventName"
                flexDirection="column"
                required
              />
            </Grid>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <CustomMultilineInput
                control={control}
                errors={!!errors?.msgContent}
                errorText={errors?.msgContent?.message}
                placeholder="Enter template content"
                label="Template Content"
                name="msgContent"
                required
                flexDirection="column"
              />
            </Grid>
            <Grid container item justifyContent="flex-end">
              <Button variant="contained" color="secondary" onClick={handleSubmit(manageTemplate)}>
                Save
              </Button>
            </Grid>
          </Grid>
        )}
        {watchManageTemplate === 'list' && (
          <BidirectionalTemplateList dropDownList={dropDownList} />
        )}
      </Grid>
    </Box>
  );
};

export default ManageBidirectionalTemplate;
